// src/components/MobileMenu.js
import React, { useState } from 'react';
import { FaHome, FaBuilding, FaChartLine, FaFileUpload, FaSignOutAlt, FaBars, FaTimes, FaList, FaClipboardCheck, FaPaperPlane } from 'react-icons/fa';
import { TbFileExport } from 'react-icons/tb';
import { NavLink, useNavigate } from 'react-router-dom';

function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const userRoles = (() => {
    try {
      const rolesJson = localStorage.getItem('roles');
      if (rolesJson) {
        const parsed = JSON.parse(rolesJson);
        if (Array.isArray(parsed) && parsed.length > 0) return parsed.map(r => r.role);
      }
    } catch (e) {}
    const legacyRole = localStorage.getItem('role');
    return legacyRole ? [legacyRole] : [];
  })();

  const canAccess = (roles) => roles.some(r => userRoles.includes(r));

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    navigate('/login');
  };



  return (
    <>
      <button
        className="md:hidden fixed top-2 left-2 z-[999] bg-teal-600 text-white p-2 rounded-lg shadow-lg"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
      </button>

      {isOpen && (
        <div className="md:hidden fixed inset-0 bg-black/50 z-40" onClick={() => setIsOpen(false)}>
          <div 
            className="bg-white w-64 h-full p-4 shadow-xl overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center gap-2 mb-6">
              <img 
                src="/logo-mark.png" 
                alt="Treta" 
                className="w-8 h-8 object-contain"
              />
              <span className="font-bold text-teal-600">Treta</span>
            </div>
            
            <nav className="space-y-2">
              {/* Home */}
              <NavLink 
                to="/" 
                className="flex items-center gap-3 p-2 hover:bg-teal-50 rounded"
                onClick={() => setIsOpen(false)}
              >
                <FaHome /> Home
              </NavLink>
              
              {/* Properties */}
              <NavLink 
                to="/properties" 
                className="flex items-center gap-3 p-2 hover:bg-teal-50 rounded"
                onClick={() => setIsOpen(false)}
              >
                <FaBuilding /> Properties
              </NavLink>
              
              {/* Insights */}
              <NavLink 
                to="/insights" 
                className="flex items-center gap-3 p-2 hover:bg-teal-50 rounded"
                onClick={() => setIsOpen(false)}
              >
                <FaChartLine /> Insights
              </NavLink>

              {/* My Properties */}
              {canAccess(['admin', 'team_lead', 'rep', 'broker']) && (
                <NavLink 
                  to="/my-properties" 
                  className="flex items-center gap-3 p-2 hover:bg-teal-50 rounded"
                  onClick={() => setIsOpen(false)}
                >
                  <FaList /> My Properties
                </NavLink>
              )}

              {/* Approvals */}
              {canAccess(['admin', 'team_lead']) && (
                <NavLink 
                  to="/team-lead-dashboard" 
                  className="flex items-center gap-3 p-2 hover:bg-teal-50 rounded"
                  onClick={() => setIsOpen(false)}
                >
                  <FaClipboardCheck /> Approvals
                </NavLink>
              )}

              {/* Client Send */}
              {canAccess(['admin', 'team_lead', 'rep', 'broker']) && (
                <NavLink 
                  to="/client-send" 
                  className="flex items-center gap-3 p-2 hover:bg-teal-50 rounded"
                  onClick={() => setIsOpen(false)}
                >
                  <FaPaperPlane /> Client Send
                </NavLink>
              )}

              {/* Export */}
              {canAccess(['admin', 'team_lead', 'rep', 'broker']) && (
                <NavLink 
                  to="/export" 
                  className="flex items-center gap-3 p-2 hover:bg-teal-50 rounded"
                  onClick={() => setIsOpen(false)}
                >
                  <TbFileExport /> Export
                </NavLink>
              )}
              
              {/* Submit Property */}
              {canAccess(['team_lead', 'rep', 'broker']) && (
                <NavLink 
                  to="/submit-property" 
                  className="flex items-center gap-3 p-2 hover:bg-teal-50 rounded"
                  onClick={() => setIsOpen(false)}
                >
                  <FaFileUpload /> Submit Property
                </NavLink>
              )}
              
              {/* Logout */}
              <button
                onClick={() => {
                  handleLogout();
                  setIsOpen(false);
                }}
                className="flex items-center gap-3 p-2 hover:bg-red-50 rounded w-full text-left"
              >
                <FaSignOutAlt /> Logout
              </button>
            </nav>
          </div>
        </div>
      )}
    </>
  );
}

export default MobileMenu;